module.exports = __webpack_public_path__ + "static/3-5e81ced9c9a6d0f2d6856fa17bc100c5.png";